const validateDecimalNumber = (value: string) => {
  const floatRegExp = new RegExp('^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$');

  if (value === '' || floatRegExp.test(value)) {
    return value;
  }
};

export default validateDecimalNumber;
